module.exports = __webpack_public_path__ + "img/conny-stage6-sulking.9d3595ea.png";